import { render, staticRenderFns } from "./LoadingError.vue?vue&type=template&id=4a971736&scoped=true&"
import script from "./LoadingError.vue?vue&type=script&lang=js&"
export * from "./LoadingError.vue?vue&type=script&lang=js&"
import style0 from "./LoadingError.vue?vue&type=style&index=0&id=4a971736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a971736",
  null
  
)

export default component.exports